// removed by extract-text-webpack-plugin
module.exports = {"container":"_3wYFryj","container__hidden":"_254uRVH"};


//////////////////
// WEBPACK FOOTER
// ./template/components/SearchForm/SearchControls/index.css
// module id = ./template/components/SearchForm/SearchControls/index.css
// module chunks = client.sitechrome